window.addEventListener("DOMContentLoaded", function () {
  if (!customElements.get("header-nav")) {
    class HeaderNav extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.initEvent();
        this.initFirstActive()
        this.initEventListeners();
      }

      initEvent() {
        const btn = this.querySelectorAll(".header-link-btn");
        if (!btn) return;
        for (let btn_item of btn) {
          btn_item.addEventListener("click", (e) => {
            window.open(btn_item.dataset.href, "_blank");
          });
        }


        for (const parent of this.querySelectorAll('.site-nav--has-dropdown')) {
          const $parents = $(parent);
          $parents.on('mouseenter touchstart', this.onHoverParentNav);
        }
      }

      onHoverParentNav(e) {
        const target = e.currentTarget;
        if (target) {
          const navSwiperElements = target.querySelectorAll('header-nav-swiper');
          for (const navSwiper of navSwiperElements) {
            navSwiper.init();
          }
        }
      }

      initFirstActive(){
        const left_container_list = this.querySelectorAll(".left_nav-content")
       for(let item of left_container_list){
         const obj=item.querySelector(".menu-item.active")
         let name=obj.getAttribute("data-class_name")
         let customName = obj.querySelector(".header-title-custom") ? obj.querySelector(".header-title-custom").innerText : ""
         let url=obj.getAttribute("data-link")
         let subtitle=obj.querySelector(".header-title-content") ? obj.querySelector(".header-title-content").innerText:''
         item.parentElement.querySelector(".right_nav-active-text .active-left_text").innerText=customName || name
         item.parentElement.querySelector(".right_nav-active-text .active-left_subtitle").innerText=subtitle
        //  item.parentElement.querySelector(".right_nav-active-text .active-link a").setAttribute("href",url)
       }
      }
      initEventListeners() {
        const menuItems = document.querySelectorAll(".site-nav__image-status .menu-item");
        menuItems.forEach(function(menuItem) {
          menuItem.addEventListener("mouseenter", function () {
            const index = parseInt(this.getAttribute("data-index")) - 1;
            const name = this.getAttribute("data-name");
            const class_name = this.getAttribute("data-class_name");
            const customName = this.querySelector(".header-title-custom") ? this.querySelector(".header-title-custom").innerText : ""
            const headerTitleContent = this.querySelector(".header-title-content");
            const subtitle = headerTitleContent ? headerTitleContent.textContent : '';
            
            // 添加active类并移除兄弟元素的active类
            this.classList.add("active");
            const siblings = Array.from(this.parentElement.children).filter(el => el !== this);
            siblings.forEach(el => el.classList.remove("active"));
            
            // 查找最近的.site-nav__image-status父元素
            const imageStatus = this.closest(".site-nav__image-status");
            if(imageStatus){
              // 设置right_nav-content的active项
              const rightNavItems = Array.from(imageStatus.querySelectorAll(".right_nav-content>.item"));
              rightNavItems.forEach((item, i) => {
                if(i === index){
                  item.classList.add("active");
                } else {
                  item.classList.remove("active");
                }
              });
              
              // 设置active-left_text
              const activeLeftText = imageStatus.querySelector(".right_nav-active-text .active-left_text");
              if(activeLeftText){
                activeLeftText.textContent = customName || class_name;
              }
              const activeLeftSubtitle = imageStatus.querySelector(".right_nav-active-text .active-left_subtitle");
              if(activeLeftSubtitle){
                activeLeftSubtitle.textContent = subtitle;
              }
            }
            
            // 查找最近的.left_nav-content父元素
            const leftNavContent = this.closest(".left_nav-content");
            if(leftNavContent){
              const menuDownLists = leftNavContent.querySelectorAll(`.header_nav-link-box .menu-down_list[data-name="${name}"]`);
              menuDownLists.forEach(list => {
                list.classList.add("active");
                const listSiblings = Array.from(list.parentElement.children).filter(el => el !== list);
                listSiblings.forEach(el => el.classList.remove("active"));
              });
            }
          });
        });
        
        if (window.innerWidth > 1000) {
          const headerSection = document.getElementById("shopify-section-header");
          if(headerSection){
            headerSection.addEventListener("mouseleave", function () {
              const allElements = this.querySelectorAll("*");
              allElements.forEach(el => el.blur());
            });
          }
        }
        
        const languageBox = document.querySelectorAll(".choose-language-box");
        languageBox.forEach(item => {
            item.addEventListener("click", function () {
                const isExpanded = this.getAttribute("aria-expanded") === "true";

                this.setAttribute("aria-expanded", !isExpanded);

                document.querySelector(".pc-language-box .website_change_wrapper .item")?.click();
            });
        });

      }
    }
    customElements.define("header-nav", HeaderNav);
  }
  if (!customElements.get("header-nav-swiper")) {
    class HeaderNavSwiper extends HTMLElement {
      isFirstInit = true;
      constructor() {
        super();
        this.swiper = null;
        this.variant_btn = this.querySelectorAll(".header_variants-container");
      }

      init() {
        if (!this.isFirstInit) return;
        this.initSwiper();
        this.resizeEvent();
        this.initBtnEvent();
        this.initMbEvent();
        this.isFirstInit = false;
      }
      initBtnEvent() {
        for (let item of this.variant_btn) {
          let item_span = item.querySelectorAll("span");
          for (let item_child of item_span) {
            item_child.addEventListener("click", () => {
              const img_url = item_child.getAttribute("data-img_url");
              for (const child of item_child.parentElement.children) {
                child.classList.remove("active");
              }
              item_child.classList.add("active");
              item_child.parentElement.parentElement.parentElement.querySelector(
                ".site-nav__dropdown-linka img"
              ).src = img_url;
            });
          }
        }
      }
      initSwiper() {
        if (!!this.swiper) return;
        const swiperContainer = this.querySelector(".swiper-container");
        const scrollbar = this.querySelector(".swiper-scrollbar");
        let allowTouch =
          this.getAttribute("data-allow-touch") == "false" ? false : true;
        if (!swiperContainer) return;
        this.swiper = new Swiper(swiperContainer, {
          slidesPerView: "auto",
          allowTouchMove: allowTouch,
          observer: true,
          observeParents: true,
          scrollbar: {
            el: scrollbar,
            draggable: true,
          },
          navigation: {
            nextEl: this.querySelector(".swiper-button-prev"),
            prevEl: this.querySelector(".swiper-button-next"),
          },
        });
      }

      resizeEvent() {
        if (window.innerWidth < 1300) {
          this.swiper ? (this.swiper.allowTouchMove = true) : null;
        }
        window.addEventListener("resize", () => {
          if (this.swiper) {
            this.swiper.update();
          }
        });
      }
      initMbEvent() {
        if (window.innerWidth <= 1100) {
          let btn_items = this.querySelectorAll(".mobile-nav__toggle-btn");
          for (let btn_i of btn_items) {
            btn_i.addEventListener("click", () => {
              this.initSwiper();
            });
          }
        }
      }
    }
    customElements.define("header-nav-swiper", HeaderNavSwiper);
  }
  if (!customElements.get("drawer-menu")) {
    class DrawerMenu extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.initEventListeners();
      }
      initEventListeners() {
        const btn_link = this.querySelector(".drawer-menu-search-icon");
        btn_link.addEventListener("click", () => {
          document.querySelector(".site-nav__link--burger").click();
          document.querySelector(".new-search-container").click();
        });
      }
    }
    customElements.define("drawer-menu", DrawerMenu);
  }
  if (!customElements.get("header-drawer-menu")) {
    class HeaderDrawerMenu extends HTMLElement {
      constructor() {
        super();
        this.swiper_list_arr = [];
        this.variant_btn = this.querySelectorAll(".header_variants-container");
        this.swiper_list = this.querySelectorAll(".swiper-container");
        this.mobile_nav__imglink = this.querySelectorAll(
          ".mobile-nav__imglink"
        );
      }
      connectedCallback() {
        this.initEventListeners();
        this.initBtnEvent();
      }
      initBtnEvent() {
        for (let item of this.variant_btn) {
          let item_span = item.querySelectorAll("span");
          for (let item_child of item_span) {
            item_child.addEventListener("click", () => {
              const img_url = item_child.getAttribute("data-img_url");
              for (const child of item_child.parentElement.children) {
                child.classList.remove("active");
              }
              item_child.classList.add("active");
              item_child.parentElement.parentElement.parentElement.querySelector(
                ".site-nav__dropdown-linka img"
              ).src = img_url;
            });
          }
        }
      }
      initEventListeners() {
        for (let item of this.mobile_nav__imglink) {
          item.addEventListener("click", () => {
            let timer_id = setTimeout(() => {
              this.initSwiper();
              clearTimeout(timer_id);
            }, 100);
          });
        }
      }
      initSwiper() {
        if (this.swiper_list_arr.length > 0) return;
        for (let swiper_item of this.swiper_list) {
          const scrollbar = swiper_item.querySelector(".swiper-scrollbar");
          let swiper = new Swiper(swiper_item, {
            slidesPerView: "auto",
            scrollbar: {
              el: scrollbar,
              draggable: true,
            },
          });
          this.swiper_list_arr.push(swiper);
        }
      }
    }
    customElements.define("header-drawer-menu", HeaderDrawerMenu);
  }
});
